module.exports = __webpack_public_path__ + "img/slider-2.376d3d11.jpg";